<div
  class="account-dropdown"
  #accountPopover="ngbPopover"
  [ngbPopover]="personalMenuTemplate"
  [triggers]="'manual'"
  [autoClose]="'outside'"
  [animation]="false"
  [popperOptions]="popperOptions"
  [popoverClass]="'account-dropdown__popover'"
  (click)="accountPopover.toggle()"
>
  <ftr-user-avatar size="ExtraLarge" [user]="(user$ | async) ?? undefined"></ftr-user-avatar>
  <ftr-icon align="Middle" [icon]="accountPopover.isOpen() ? 'KeyboardArrowUp' : 'KeyboardArrowDown'"></ftr-icon>
</div>

<ng-template #personalMenuTemplate>
  <ftr-personal-menu></ftr-personal-menu>
</ng-template>
